import { render } from "./Home.vue?vue&type=template&id=aa6a0a0a"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
script.render = render

export default script